export default {
  fundDetail: '资金明细',
  tradeStartDate: '交易开始日',
  tradeEndDate: '交易结束日',
  tradeNo: '交易编号',
  recharge: '充值',
  rechargeLog: '充值记录',
  relationOrderNo: '关联订单号',
  tradeIntro: '交易说明',
  tradeTime: '交易时间',
  tradeType: '交易类型',
  amount: '金额',
  address: '地址',
  balance: '余额',
  payPack: '装箱单付款',
  payOrder: '订单付款',
  compensate: '赔偿',
  deduct: '扣款',
  withdrawal: '退金（提现）',
  fund1: '购买完扣费',
  fund2: '退货退费',
  fund3: '异常扣费',
  fund4: '同捆付款',
  fund5: '仓库保管费',
  fund6: '检品完扣费',
  fund7: '账单付款',
  fund8: '取消购买退费',
  fund9: '取消检品退费',
  fund10: '换回详细检品费',
  fund11: '退回仓储费',
  fund12: '仓储费',
  fund13: '国际运费退回',
  fund14: '上述金额按1 元＝{rate} 日元的汇率换算得出。',
  fund15: '国际运费及关税未包含在本报价单内，商品送达后将按实际费用进行结算。',
  fund16: '手续费按（商品金额＋中国国内运费）×{rate}% 的公式计算得出。',
  fund17: '有效期：自本报价单出具之日起 1 周',
  fund18: '无法购买退费',
  fund20: '检品费退费',
  fund21: '检品费退费',
  itemCost: '商品金额',
  domesticFreight: '中国国内运费',
  formulaPrefix: '手续费按',
  formulaSuffix: ' 的公式计算得出。',
  yen: '元',
  pricePrefix: '价格 >',
  yuan: '元',
  agentServiceFee: '代购手续费',
  totalPrice: '总费用',
  paymentMethod: '支付方式',
  bankPay: '银行卡支付',
  useBalance: '使用余额',
};
